module.exports = {
    config: Object.freeze(window.__js_bridge),
    state: {
        svgSymbolsLoaded: false,
        googleRecaptchaLoaded: false,
    },
};
